import axios from "axios";
import * as authAction from "../actions/authActions";
import { errorToast, errorNetworkToast } from "../components/Toast";
import { getAuthToken } from "../helpers/storage";
import { AuthenticationType, getAuthenticationType } from "../constants/AuthenticationType";
import { SIGNED_HEADERS, ACCEES_KEY, SECRET_KEY } from "../constants/AuthenticationTypeHMAC";

import { computeSignature } from "./authentication/authenticationHMAC";

/**
 * Metoda ustawiajaca nagłówek autoryzacyjny na wszystkich requestach w zależnośći od wybranego typu autoryzacji 
 */
export const axiosRequestAuthHeader = () => {

  //pobieramy ustawiony typ autoryzacji
  let authenticationType = getAuthenticationType();

  switch (authenticationType) {
    case AuthenticationType.JWT:
      axiosRequestAuthHeaderJWT();
      break;
    case AuthenticationType.HMAC:
      axiosRequestAuthHeaderHMAC();
      break;
    case AuthenticationType.BASIC:
      axiosRequestAuthHeaderBASIC();
      break;
    default:
      console.error('No authorization type selected');
  }

};

/**
 * Metoda ustawiajaca nagłówek autoryzacyjny na wszystkich requestach
 * 
 * Implementacja tokena JWT czyli nagłówek Autorization ustawiamy: Bearer tokenJWT
 */
const axiosRequestAuthHeaderJWT = () => {
  // add authorization header with JWT token

  const token = getAuthToken();

  if (token && token.tokenType && token.accessToken) {
    axios.defaults.headers.common["Authorization"] = `${token.tokenType} ${
      token.accessToken
      }`;
  }
};

/**
 * Metoda ustawiajaca nagłówek autoryzacyjny na wszystkich requestach
 */
const axiosRequestAuthHeaderHMAC = () => {
  // add authorization header with HMAC token

  //algorytm hmac
  const ALGORITHM = AuthenticationType.HMAC.type;

  //https://stackoverflow.com/questions/43051291/attach-authorization-header-for-all-axios-requests
  // Add a request interceptor
  axios.interceptors.request.use((config) => {
    // Do something before request is sent

    //dodajemy wymagane nagłówki do autoryzacji hmac
    //config.headers[SIGNED_HEADERS.X_FLOW_DATE] = new Date().toISOString();

    // test przykaldowego naglowka - z tego poziomu nie mamy restauracji
    config.headers[SIGNED_HEADERS.X_FLOW_RID] = '  1059  ';

    //test parametru
    if (!config.params) {
      //inicjalizacja
      config.params = {};
    }
    config.params[SIGNED_HEADERS.X_FLOW_DATE] = new Date().toISOString();
    //mapa z nagłówkami/parametrami, które biorą udział w podpisie
    const signedHeaderMap = getRequiredHeaderOrParam(SIGNED_HEADERS, config)
    //obliczenie podpisu
    config.headers['Authorization'] = `${ALGORITHM} ${computeSignature(config.url, config.method, signedHeaderMap, ACCEES_KEY, SECRET_KEY)}`

    return config;
  }, (error) => {
    // Do something with request error
    console.log(error)
    return Promise.reject(error);
  });

};

/**
 * Metoda ustawiajaca nagłówek autoryzacyjny na wszystkich requestach
 * 
 * Implementacja Basic czyli nagłówek Autorization ustawiamy: Basic base64(login:haslo)
 * 
 */
const axiosRequestAuthHeaderBASIC = () => {
  // add authorization header with JWT token

  const token = getAuthToken();

  if (token) {
    axios.defaults.headers.common["Authorization"] = `Basic ${token}`;
  }
};

/**
 * Zwraca mapę, gdzie kluczem jest nazwa nagłówka, a wartością jego wartość wyciągnieta z requestu
 * 
 * @param {SIGNED_HEADERS} signedHeaders model nagłówków, które biorą udział w podpisywaniu requestu
 * @param {*} config konfiguracja axios 
 */
const getRequiredHeaderOrParam = (signedHeaders, config) => {

  //mapa gdzie kluczem jest nazwa nagłówka, a wartościa jego wartość
  let result = new Map();

  //nazwy nagłówków biorące udział w podpisie
  let signedHeaderNames = Object.values(signedHeaders)
  //iterujemy przez wszystkie nagłówki i dodajemy do mapy
  signedHeaderNames.forEach(headerName => {

    //sprawdzamy w nagłówkach i parametrach
    if (config.headers[headerName]) {
      //istnieje taki nagłówek
      result.set(headerName, config.headers[headerName])
    }
    else {
      //nagłówek nie istnieje, badamy parametry
      if (config.params) {
        if (config.params[headerName]) {
          //parametr istnieje
          result.set(headerName, config.params[headerName])
        }
      }
    }

  }
  );

  return result;
}

/**
 * Globalna obsługa błędów odpowiedzi z serwera
 * 
 * W przypadku zwrotki z serwera 401(brak autoryzacji) - wylogowujemy i automatycznie przekierowujemy na widok logowania
 * 
 * W przypadku zwrotki z serwera 403(brak dostępu) - automatycznie przekierowujemy na widok główny aplikacji - home
 * 
 */
export const axiosResponseErrorHandler = () => {
  axios.interceptors.response.use(
    response => {
      // Do something with response data
      return response;
    },
    error => {
      // Do something with response error
      if (error.response) {
        //obsluga statusow

        // brak autoryzacji - wylogujemy uzytkownika
        if (error.response.status === 401) {
          authAction.doLogout();
        }

        // brak dostepu - przekierowanie na home
        if (error.response.status === 403) {
          authAction.doHome();
        }

        errorToast(error.response.data);

      } else {
        // network error
        errorNetworkToast();
      }

      return Promise.reject(error);
    }
  );
};
